
import Popup from 'vux/src/components/popup/index.vue'

import { mapState, mapGetters } from 'vuex'
import { SET_CUSTOMER_VISIBLE } from '../../store/nameSpace'

export default {
name: 'CustomerService',
components: { Popup },
data () {
return {
customer: {

show: false
}
}
},
computed: {
...mapState({
customerVisible: state => state.app.customerVisible
}),
...mapGetters([
'PORTAL_systemConfig'
]),
currentVisibleVModel: {
get () {
return this.customerVisible
},
set (val) {
this.$store.commit(SET_CUSTOMER_VISIBLE, val)
}
},
closeVisible () {
return this.$config.platform !== 'Darwinex FT'
}
},
watch: {
currentVisibleVModel () {
this.customer.show = true
}
}
}



// WEBPACK FOOTER //
// ./src/components/CustomerService/CustomerService.vue